const messages = {
  title: "Rinkodaros sutikimai",
  required: "Privaloma",
  answered: "✓ Atsakyta",
  read: "Perskaityta",
  notRead: "Neperskaityta",
  alreadyAnswered: "Jau atsakyta",
  requiredQuestionsMustBeAccepted:
    "Dar reikia priimti {count} privalomų klausimų",
  pleaseAnswerQuestions: "Atsakykite į šiuos klausimus:",
  iAccept: "Sutinku",
  scrollToUnlock: "Norėdami atrakinti, slinkite iki galo",
  fieldRequired: "Šis laukas privalomas",
  scrollToContinue: "↓ Norėdami tęsti, slinkite iki galo",
  saving: "Išsaugoma...",
  saveConsents: "Išsaugoti sutikimus",
  allRequiredAccepted: "✓ Visi privalomi klausimai priimti",
  requiredConsentsCompleted:
    "{completed}/{total} privalomų sutikimų užpildyta",
  selectConsentToView:
    "Pasirinkite sutikimą iš sąrašo, kad peržiūrėtumėte turinį",
  readAllContentFirst: "Pirmiausia perskaitykite visą turinį: {names}",
  acceptAllRequiredIn:
    "Priimkite visus privalomus klausimus: {names}",
  acceptAllBeforeSaving:
    "Prieš išsaugodami priimkite visus privalomus klausimus.",
  failedToSave: "Nepavyko išsaugoti sutikimų. Bandykite dar kartą.",
  errorSaving:
    "Išsaugant sutikimus įvyko klaida. Bandykite dar kartą.",
  failedToLoad: "Nepavyko įkelti sutikimų. Atnaujinkite puslapį.",
  viewPdf: "Rodyti PDF",
  requiredConsentTitle: "Privalomas sutikimas",
  acceptAndContinue: "Priimti ir tęsti",
};

export default {
  messages,
};
